import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { type RootState } from '@/store';
import { UserData } from '@/api';

interface UsersListState {
  usersListData: UserData[];
}

const initialState: UsersListState = {
  usersListData: []
};

const usersListSlice = createSlice({
  name: 'usersList',
  initialState: initialState,
  reducers: {
    setUsersListData: (state, action: PayloadAction<UserData[]>) => {
      state.usersListData = action.payload;
    }
  }
});

export const { setUsersListData } = usersListSlice.actions;

export const selectUsersListData = (state: RootState) => {
  return state.usersList.usersListData;
};

export const usersListReducer = usersListSlice.reducer;
